import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=2e79234e&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=2e79234e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79234e",
  null
  
)

export default component.exports